import { useEffect, useState } from "react";
import { QrCode, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, SectionCard } from "@/components/ui-helpers";
import StoreQRPoster from "@/components/StoreQRPoster";

export default function SellerPromote() {
  const [sf, setSf] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const nav = useNavigate();
  useEffect(() => {
    api.get("/marketplace/storefront/me").then((r) => setSf(r.data.storefront)).catch(() => {}).finally(() => setLoaded(true));
  }, []);
  const storeUrl = sf?.slug ? `${window.location.origin}/${sf.slug}` : "";

  return (
    <div data-testid="seller-promote-page">
      <PageHeader title="Promote your store" icon={QrCode} subtitle="A ready-to-share QR poster that opens your store on Suffle. Download it, print it, or share the link anywhere." />
      <SectionCard title="Store QR poster" icon={QrCode} testid="promote-card">
        {!loaded ? (
          <p className="text-sm text-slate-400">Loading…</p>
        ) : sf?.slug ? (
          <StoreQRPoster storeName={sf.name || "Your Store"} storeUrl={storeUrl} slug={sf.slug} logo={sf.logo} accent={sf.accent || "#7c3aed"} />
        ) : (
          <div data-testid="promote-no-slug">
            <p className="mb-3 text-sm text-slate-500">Set your <b>Store URL</b> first — then your personalized QR poster appears here.</p>
            <button onClick={() => nav("/seller/storefront")} className="inline-flex items-center gap-1.5 rounded-full brand-gradient-bg px-5 py-2.5 text-sm font-semibold text-white">Set Store URL <ArrowRight className="h-4 w-4" /></button>
          </div>
        )}
      </SectionCard>
    </div>
  );
}
